import React, { useState, useEffect } from "react";
import Modal from "components/common/Modal";
import { InputField } from "components/FormFields";
import CustomButton from "components/CustomButton";

export default function VisitorEditModal({ open, onClose, initialData, onSubmit, loading }) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    companyName: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (initialData) {
      setFormData({
        firstName: initialData.firstName || "",
        lastName: initialData.lastName || "",
        email: initialData.email || "",
        companyName: initialData.companyName || "",
      });
      setErrors({});
    }
  }, [initialData]);

  const validate = () => {
    const errs = {};
    if (!formData.firstName.trim()) errs.firstName = "First name is required";
    if (!formData.lastName.trim()) errs.lastName = "Last name is required";
     if (!formData.companyName.trim()) errs.companyName = "Company name is required";
    if (!formData.email.trim()) {
      errs.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errs.email = "Invalid email format";
    }
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      onSubmit(formData);
    }
  };

  return (
    <Modal open={open} title="Edit Visitor Details" onClose={onClose}>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4 p-1">
        <InputField
          label="FIRST NAME"
          name="firstName"
          value={formData.firstName}
          onChange={handleChange}
          error={errors.firstName}
          required
        />
        <InputField
          label="LAST NAME"
          name="lastName"
          value={formData.lastName}
          onChange={handleChange}
          error={errors.lastName}
          required
        />
        <InputField
          label="EMAIL"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          error={errors.email}
          required
        />
        <InputField
          label="COMPANY NAME"
          name="companyName"
          value={formData.companyName}
          onChange={handleChange}
          error={errors.companyName}
        />

        <div className="mt-4 flex justify-end gap-2 border-t pt-4">
          <CustomButton
            label="Cancel"
            variant="outline"
            color="#1A1A1A"
            borderColor="#e5e7eb"
            onClick={onClose}
            type="button"
          />
          <CustomButton
            label={loading ? "Saving..." : "Save Changes"}
            variant="solid"
            color="#02a9e0"
            disabled={loading}
            type="submit"
          />
        </div>
      </form>
    </Modal>
  );
}